/* eslint-disable no-nested-ternary */
import {
  OutboundDespatchNoteProduct,
  OutboundPlannedPickLine,
} from '@features/supplyChain/types';
import { numberToLocale } from '@forms/client/AddProductForm/utils';
import { plannedSkuIdentifiersForProduct } from '../../../../utils/despatch';

interface ProductLinesSectionProps {
  products: OutboundDespatchNoteProduct[];
  plannedLines?: OutboundPlannedPickLine[] | null;
  isDesktop: boolean;
  isTablet: boolean;
}

export function ProductLinesSection({
  products,
  plannedLines,
  isDesktop,
  isTablet,
}: ProductLinesSectionProps) {
  const skuSourceFor = (
    product: OutboundDespatchNoteProduct
  ): string | null => {
    const plannedSkuIdentifiers = plannedSkuIdentifiersForProduct(
      plannedLines,
      product.productId
    );
    if (plannedSkuIdentifiers.length > 0) {
      return `${
        plannedSkuIdentifiers.length === 1 ? 'SKU' : 'SKUs'
      } ${plannedSkuIdentifiers.join(', ')}`;
    }
    if (product.skuIds?.length) {
      return `from ${product.skuIds.length} SKU${
        product.skuIds.length === 1 ? '' : 's'
      }`;
    }
    return null;
  };

  return (
    <>
      {isDesktop && (
        <div className='grid grid-cols-[2.5rem_1fr_1fr] gap-4 pb-3 border-b border-gray-200 mb-4'>
          <span className='text-xs font-semibold text-gray-500 text-center'>
            #
          </span>
          <span className='text-xs font-semibold text-gray-500'>Product</span>
          <span className='text-xs font-semibold text-gray-500'>Quantity</span>
        </div>
      )}

      <div className='flex flex-col gap-4'>
        {products.map((product, index) => {
          const skuSource = skuSourceFor(product);
          return (
            <div
              key={product.productId}
              className={`${
                index !== products.length - 1
                  ? 'pb-4 border-b border-gray-100'
                  : ''
              }`}
            >
              {isDesktop ? (
                <div className='grid grid-cols-[2.5rem_1fr_1fr] gap-4 items-start'>
                  <div className='flex justify-center'>
                    <span className='inline-flex items-center justify-center w-7 h-7 text-xs font-medium text-gray-700 bg-gray-100 rounded-full'>
                      {index + 1}
                    </span>
                  </div>
                  <div className='flex flex-col gap-0.5'>
                    <span className='text-sm text-gray-900'>
                      {product.productName || product.productId}
                    </span>
                    {skuSource && (
                      <span className='text-xs text-gray-500'>{skuSource}</span>
                    )}
                  </div>
                  <span className='text-sm text-gray-900'>
                    {`${numberToLocale(product.productQuantity)} product${
                      product.productQuantity === 1 ? '' : 's'
                    }`}
                  </span>
                </div>
              ) : (
                <div className='flex gap-3'>
                  <div className='flex-shrink-0'>
                    <span className='inline-flex items-center justify-center w-7 h-7 text-xs font-medium text-gray-700 bg-gray-100 rounded-full'>
                      {index + 1}
                    </span>
                  </div>
                  <div
                    className={`flex-1 grid gap-3 ${
                      isTablet ? 'grid-cols-2' : 'grid-cols-1'
                    }`}
                  >
                    <div className='flex flex-col gap-0.5'>
                      <span className='text-xs font-medium text-gray-500'>
                        Product
                      </span>
                      <span className='text-sm text-gray-900'>
                        {product.productName || product.productId}
                      </span>
                      {skuSource && (
                        <span className='text-xs text-gray-500'>
                          {skuSource}
                        </span>
                      )}
                    </div>
                    <div className='flex flex-col gap-0.5'>
                      <span className='text-xs font-medium text-gray-500'>
                        Quantity
                      </span>
                      <span className='text-sm text-gray-900'>
                        {`${numberToLocale(product.productQuantity)} product${
                          product.productQuantity === 1 ? '' : 's'
                        }`}
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}
